import src from "IMAGE";
export default { src, width: 816, height: 1360, blurWidth: 5, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAI0lEQVR42sXIsQ0AAAgCMP5/WByMDoaEDxi6FOxZKT54SjYPhe+dBU6dh/gAAAAASUVORK5CYII="};
